import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { IModalComponentProps } from '@context/modal_context';

const CancelCardReasonModal: FC<IModalComponentProps<{ reason_id: string | number }>> = ({
    modalData,
    changeModalData,
    handleChangeDisable
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'cancel_card_reason'
    });

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {t('title')}
            </Typography>
            <Typography variant="body3" alignment="center" className={styles.description}>
                Are you sure you want to cancel this card? Once canceled, it will be permanently
                disabled and can’t be used for payments.
            </Typography>
        </div>
    );
};

export default CancelCardReasonModal;
